__webpack_require__.p = "/department-economics/";